// Theme Watcher - Syncs DOM theme changes with Redux store

import { themeChanged } from '../reducers/ThemeReducer';

/**
 * Initialize theme watcher to sync DOM changes with Redux
 * @param {Object} store - Redux store instance
 */
export const initializeThemeWatcher = (store) => {
  // Set initial theme from DOM
  const initialTheme = document.body.getAttribute('data-theme') || 'light';
  store.dispatch(themeChanged(initialTheme));

  // Watch for theme changes in DOM
  const observer = new MutationObserver(() => {
    const newTheme = document.body.getAttribute('data-theme') || 'light';
    const currentTheme = store.getState().theme?.currentTheme;
    
    // Only dispatch if theme actually changed
    if (newTheme !== currentTheme) {
      store.dispatch(themeChanged(newTheme));
    }
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['data-theme'],
  });

  return () => observer.disconnect();
};